import React, { useState } from 'react'
import { 
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControl,
    Select,
    MenuItem 
} from '@material-ui/core'
import authService from './api-authorization/AuthorizeService'

export default function BookingApprovalButton({
    booking, // from shipmentDetailPage.js
    clientId,
    selectedRows, // from shipmentTable.js
    ...props
}) {
    const [modalOpen, setModalOpen] = useState(false)
    const [transportMode, setTransportMode] = useState('SEA')
    const [selectedBookings, setSelectedBookings] = useState(null)

    const handleApproveClick = (e) => {
        e.stopPropagation() // Prevent event bubbling
        const bookingNumbers = (typeof selectedRows === 'function' ? selectedRows() : selectedRows)?.map(r => r.shipmentNumber) || [] // Get the actual rows from the function if selectedRows is a function
        setSelectedBookings(bookingNumbers && bookingNumbers.length > 0 ? bookingNumbers : (booking ? ['S' + booking.houseBillNumber] : [])) // If no rows are selected, use the booking number from the shipment detail page
        setModalOpen(true)
    }
    
    const handleModalClose = () => {
        setModalOpen(false)
    }

    const handleConfirmApprove = async () => {
        setModalOpen(false)

        try {
            const token = await authService.getAccessToken()
            const response = await fetch('api/shipments/ApproveBookings', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ClientId: clientId,
                    BookingNumbers: selectedBookings,
                    TransportMode: transportMode,
                    Consignee: selectedBookings[0]?.consignee,
                    Destination: selectedBookings[0]?.destinationPortCode
                })
            })
        
            if (!response.ok) throw new Error(await response.text())
            alert('Booking approved successfully')
            window.location.reload()
        } catch (error) {
            alert(error.message)
        }
    }
    
    return (
        <>
            <Button
                variant="contained" 
                color="primary" 
                onClick={handleApproveClick}
            >
                { props.buttonTitle || 'Approve Booking' }
            </Button>

            <Dialog open={modalOpen} onClose={handleModalClose}>
                <DialogTitle>Approve Booking - Select Transport Mode</DialogTitle>
                <DialogContent>
                    <FormControl fullWidth>
                        <Select
                            value={transportMode}
                            onChange={(e) => setTransportMode(e.target.value)}
                        >
                            <MenuItem value="SEA">Sea</MenuItem>
                            <MenuItem value="AIR">Air</MenuItem>
                            <MenuItem value="COU">Courier</MenuItem>
                            <MenuItem value="ROA">Road</MenuItem>
                            <MenuItem value="RAI">Rail</MenuItem>
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button 
                        onClick={handleModalClose} 
                        color="primary"
                        variant="contained"
                    >
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleConfirmApprove} 
                        color="primary"
                        variant="contained"
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
